<template>
  <div>
    <el-row class="querypanel">
      <el-col :span="12"><div class="queryinput">
        <el-input v-model="newpagename" placeholder="请输入新的页面名称"></el-input>
      </div></el-col>
      <el-col :span="12"><div class="queryinput">
        <el-input v-model="newpageurl" placeholder="请输入新的页面链接"></el-input>
      </div></el-col>
      <el-col :span="12">
        <div>
          <el-button style="margin-top: 15px; margin-left: 10px;" @click="createnewpage">创建新页面</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row class="querypanel">
      <el-table
        stripe
        :data="pagedata"
        ref="multipleTable">
        <el-table-column
          prop="groupid.String"
          width = "150px"
          label="组ID">
        </el-table-column>
        <el-table-column
          prop="name.String"
          width = "200px"
          label="页面名称">
        </el-table-column>
        <el-table-column
          prop="url.String"
          label="页面链接">
        </el-table-column>
        <el-table-column
          label="操作"
          width="80px"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="移除该资源" placement="top-start">
              <i class="fa fa-trash-o fa-lg curpointer" v-on:click="removeresource(scope.$index, ossresourcedata)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'PageInfo',
  data () {
    return {
      khid: '',
      newpagename: '',
      newpageurl: '',
      pagedata: []
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      var qstr = 'id>0'
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/qpi',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.pagedata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  },
  methods: {
    createnewpage () {
      console.log(this.newpagename)
      console.log(this.newpageurl)
      var qstr = 'cusid=8'
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/qpi',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.pagedata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/website/PageInfo.vue